import { loadShoreWidget, loadShoreIframes } from "./shore-booking-button";

const COOKIE_NAME = 'cookieConsent';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/`;
  return value;
}

function showModal() {
  const modal = document.getElementById('cookie-consent-modal');
  if (modal) modal.classList.remove('hidden');
}

function hideModal() {
  const modal = document.getElementById('cookie-consent-modal');
  if (modal) modal.classList.add('hidden');
}

function acceptAndLoadShore() {
  setCookie(COOKIE_NAME, 'true', 14);
  hideModal();

  // Immediately load Shore sticky button + iframes
  loadShoreWidget();
  loadShoreIframes();
}

function onAcceptClick() {
  acceptAndLoadShore();
}

function onDeclineClick() {
  setCookie(COOKIE_NAME, 'false', 14);
  hideModal();
}

function onPlaceholderAllowClick(event) {
  event.preventDefault();
  acceptAndLoadShore();
}

function initCookieConsent() {
  const consentManagerEnabled =
    (typeof window.__consentManagerEnabled === 'undefined')
      ? true
      : !!window.__consentManagerEnabled; // force value to strict boolean

  if (!consentManagerEnabled) return;

  const cookie = getCookie(COOKIE_NAME);

  const acceptBtn = document.getElementById('cookie-consent-accept');
  const declineBtn = document.getElementById('cookie-consent-decline');
  const placeholderAllowButtons = document.querySelectorAll('[data-shore-allow-button]');

  if (acceptBtn) acceptBtn.addEventListener('click', onAcceptClick);
  if (declineBtn) declineBtn.addEventListener('click', onDeclineClick);

  placeholderAllowButtons.forEach((btn) => {
    btn.addEventListener('click', onPlaceholderAllowClick);
  });

  if (cookie === null) {
    showModal();
  } else {
    hideModal();
  }
}

initCookieConsent();
